import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logout, isLoggedIn } from "../../Services/AuthService";
import { menuItems } from "./menuItems";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import MenuList from "./MenuList";
import UserInfo from "./UserInfo";
import InstaImg from "../../assets/instagram.png";
import callImg from "../../assets/call.png";
import locationImg from "../../assets/location.png";
import * as bootstrap from "bootstrap";
import "./NavbarMobile.css";

const NavbarMobile = ({ user }) => {
  const navigate = useNavigate();
  const userFirstName = localStorage.getItem("userFirstName");
  const userLastName = localStorage.getItem("userLastName");

  const fullName = `${userFirstName || ""} ${userLastName || ""}`.trim();

  useEffect(() => {
    const offcanvasEl = document.getElementById("profileOffcanvas");

    const handleShow = () => {
      if (offcanvasEl) {
        const body = offcanvasEl.querySelector(".offcanvas-body");
        if (body) body.scrollTop = 0;
      }
    };

    const handleHidden = () => {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
      document
        .querySelectorAll(".offcanvas-backdrop")
        .forEach((b) => b.remove());
      window.scrollTo(0, 0);
    };

    if (offcanvasEl) {
      offcanvasEl.addEventListener("show.bs.offcanvas", handleShow);
      offcanvasEl.addEventListener("hidden.bs.offcanvas", handleHidden);
    }

    return () => {
      if (offcanvasEl) {
        offcanvasEl.removeEventListener("show.bs.offcanvas", handleShow);
        offcanvasEl.removeEventListener("hidden.bs.offcanvas", handleHidden);
      }
    };
  }, []);

  const handleNavigation = (path, state = null) => {
    const offcanvasEl = document.getElementById("profileOffcanvas");
    const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasEl);

    if (bsOffcanvas) {
      bsOffcanvas.hide();
      const handleHiddenOnce = () => {
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
        document
          .querySelectorAll(".offcanvas-backdrop")
          .forEach((b) => b.remove());

        setTimeout(() => {
          if (state != null) {
            navigate(path, { state: state });
          } else {
            navigate(path);
          }
          setTimeout(() => window.scrollTo(0, 0), 100);
        }, 50);

        offcanvasEl?.removeEventListener(
          "hidden.bs.offcanvas",
          handleHiddenOnce
        );
      };

      offcanvasEl?.addEventListener("hidden.bs.offcanvas", handleHiddenOnce);
    } else {
      if (state != null) {
        navigate(path, { state: state });
      } else {
        navigate(path);
      }
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  const handleLogout = () => {
    logout();
    handleNavigation("/login");
  };

  return (
    <div className="profile-container d-flex align-items-center" dir="rtl">
      <div
        className="offcanvas offcanvas-end custom-offcanvas"
        tabIndex="-1"
        id="profileOffcanvas"
        aria-labelledby="profileOffcanvasLabel"
      >
        {/* Close Button */}
        <button
          type="button"
          className="offcanvas-close-btn"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <div className="offcanvas-body" style={{ overflowX: "hidden" }}>
          {isLoggedIn() ? (
            <UserInfo
              fullName={fullName}
              variant="mobile"
              onAvatarClick={() => handleNavigation("/user")}
            />
          ) : (
            <div className="login-section mt-5">
              <button
                className="login-btn"
                onClick={() => handleNavigation("/login")}
              >
                ورود | ثبت نام
              </button>
            </div>
          )}

          {/* Menu Section */}
          <MenuList
            items={menuItems}
            onNavigate={handleNavigation}
            onLogout={handleLogout}
            variant="mobile"
          />

          {/* Social Section */}
          <div className="social-section pt-4 pb-0">
            <div className="social-icons">
              <a href="tel:+982166910726">
                <img src={callImg} alt="Call" className="social-icon" />
              </a>
              <a
                href="https://www.instagram.com/aghili142"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={InstaImg} alt="Instagram" className="social-icon" />
              </a>
              <a
                href="https://www.google.com/maps/place/Your+Clinic+Location"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={locationImg} alt="Location" className="social-icon" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavbarMobile;
